import moment from "moment";

let formatUpdoxPhone = (phoneNumber) => {
  if (phoneNumber && (phoneNumber.length == 10 || phoneNumber.length == 11)) {
    let base = 0;
    if (phoneNumber.length > 10) {
      base = 1;
    }
    return (
      phoneNumber.substr(0 + base, 3) +
      "-" +
      phoneNumber.substr(3 + base, 3) +
      "-" +
      phoneNumber.substr(6 + base, 4)
    );
  }
  return phoneNumber || "";
};

let formatCurrencyInput = (amount) => {
  if (typeof amount == "string") {
    let amountStr = amount;
    if (amountStr.startsWith("$")) {
      amountStr = amountStr.substr(1);
    }
    if (amountStr.indexOf(",") !== -1) {
      amountStr = amountStr.replaceAll(",", "");
    }
    return Number(amountStr);
  }
  return amount;
};

let formatAmountUSD = (amount, options) => {
  const prefixSign = options?.prefixSign;
  return (prefixSign ? "$" : "") + new Number(amount).toFixed(2);
};

let formatDateToAmerican = (date) => {
  return moment(date, "YYYY-MM-DD").format("MM/DD/YYYY");
};

export {
  formatUpdoxPhone,
  formatAmountUSD,
  formatDateToAmerican,
  formatCurrencyInput,
};
